// 客户端插件：添加 passive 事件监听器支持
export default defineNuxtPlugin(() => {
	if (import.meta.client) {
		// 检测浏览器是否支持 passive 事件监听器
		let supportsPassive = false;
		try {
			const opts = Object.defineProperty({}, "passive", {
				get() {
					supportsPassive = true;
				},
			});
			window.addEventListener("testPassive", null, opts);
			window.removeEventListener("testPassive", null, opts);
		} catch (e) {
			// 浏览器不支持 passive 选项
		}

		if (supportsPassive) {
			// 重写 addEventListener 方法，为滚动相关事件自动添加 passive 选项
			const originalAddEventListener = EventTarget.prototype.addEventListener;

			EventTarget.prototype.addEventListener = function (
				type,
				listener,
				options
			) {
				// 需要设置为 passive 的事件类型
				const passiveEvents = [
					"wheel",
					"mousewheel",
					"touchstart",
					"touchmove",
					"touchend",
					"touchcancel",
				];

				if (passiveEvents.includes(type)) {
					// 如果没有指定 options 或者 options 不是对象，则创建一个新的 options 对象
					if (typeof options === "boolean" || !options) {
						options = {
							capture: options || false,
							passive: true,
						};
					} else if (
						typeof options === "object" &&
						options.passive === undefined
					) {
						// 如果 options 是对象但没有设置 passive，则添加 passive: true
						options.passive = true;
					} else if (
						typeof options === "object" &&
						options.passive === false
					) {
						// 如果明确设置了 passive: false，则保持原样
						// 移除警告以避免控制台噪音
					}
				}

				return originalAddEventListener.call(this, type, listener, options);
			};

			console.log(
				"✅ Passive event listeners enabled for better scroll performance"
			);
		}
	}
});
